import React from 'react';
import { useSpotifyAccount } from '../../hooks/useSpotifyAccount';

export default function SpotifyAccountBoundary({ children }: { children: React.ReactNode }) {
  const accountId = useSpotifyAccount();

  if (accountId === undefined) {
    return <p role="status" className="p-6 text-center text-sm text-muted-foreground">Loading Spotify connection…</p>;
  }

  return <React.Fragment key={accountId ?? 'guest'}>{children}</React.Fragment>;
}
